import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Database, ShieldCheck, RefreshCw, Landmark } from 'lucide-react';
export function ExecutiveSummary() {
  const stats = [{
    icon: Database,
    title: 'PSP Data Advantage',
    desc: 'Ground-truth merchant revenue data inaccessible to bureaus.',
    color: 'text-indigo-600',
    bg: 'bg-indigo-50'
  }, {
    icon: ShieldCheck,
    title: 'Managed Collection Risk',
    desc: 'Repayment deducted at source from daily settlement, materially reducing collection exposure versus traditional unsecured lending.',
    color: 'text-teal-600',
    bg: 'bg-teal-50'
  }, {
    icon: RefreshCw,
    title: 'Automated MDR Holdback',
    desc: 'Daily deductions adjust to actual business performance.',
    color: 'text-amber-600',
    bg: 'bg-amber-50'
  }, {
    icon: Landmark,
    title: 'Bank Balance Sheet',
    desc: 'Loans sit with the partner bank, PSP acts as infrastructure.',
    color: 'text-blue-600',
    bg: 'bg-blue-50'
  }];
  return <SectionWrapper title="Executive Summary" subtitle="This document specifies the end-to-end decisioning engine for a white-label SME cashflow lending product. The core advantage is data: the PSP holds ground-truth merchant revenue data that enables superior credit decisions at lower cost." data-id="element-56">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-57">
        {stats.map((stat, i) => {
        const Icon = stat.icon;
        return <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex items-start gap-4" data-id="element-58">
              <div className={`p-3 rounded-lg ${stat.bg} ${stat.color}`} data-id="element-59">
                <Icon className="w-6 h-6" data-id="element-60" />
              </div>
              <div data-id="element-61">
                <h3 className="font-semibold text-slate-900" data-id="element-62">{stat.title}</h3>
                <p className="text-sm text-slate-500 mt-1 leading-relaxed" data-id="element-63">
                  {stat.desc}
                </p>
              </div>
            </motion.div>;
      })}
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-64">
        <div className="px-6 py-4 border-b border-slate-200 bg-slate-50" data-id="element-65">
          <h3 className="font-semibold text-slate-900" data-id="element-66">
            Product Structure at a Glance
          </h3>
        </div>
        <div className="divide-y divide-slate-100" data-id="element-67">
          {[{
          label: 'Credit originator',
          value: 'PSP (white-labelled for bank)'
        }, {
          label: 'Credit risk holder',
          value: 'Partner bank (loans on their balance sheet)'
        }, {
          label: 'Repayment mechanism',
          value: 'Automatic MDR holdback from daily settlement'
        }, {
          label: 'Loan structure',
          value: 'Flexible — factor rate, simple interest, or amortizing P+I'
        }, {
          label: 'Primary data source',
          value: 'PSP transaction, settlement, chargeback data'
        }, {
          label: 'Target borrower',
          value: 'SMEs processing payments through the PSP'
        }].map((row, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center px-6 py-4 hover:bg-slate-50 transition-colors" data-id="element-68">
              <div className="w-1/3 text-sm font-medium text-slate-500" data-id="element-69">
                {row.label}
              </div>
              <div className="w-2/3 text-sm text-slate-900 mt-1 sm:mt-0 font-medium" data-id="element-70">
                {row.value}
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}